import { GET_FLOOR_DATA } from "../type";

const initialState = {
  list: [],
};

export default function floorReducer(state = initialState, action) {
  switch (action.type) {
    case GET_FLOOR_DATA:
      return {
        ...state,
        list: action.payload,
      };
    default:
      return state;
  }
}
